import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

import { ApiResponse, Proforma } from '@/types/mySettlementType';
import { TableFilters } from '@/pages/MySettlement/Components/TableFiltersType';

export const getSettlement = async (
  query: TableFilters
): Promise<Proforma[]> => {
  const body = {
    ...query,
  };
  try {
    const res = await apiClient.post<ApiResponse>(Endpoints.MySettlement, body);
    return (res.data.value || []).reverse();
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
